import { jsx as e, jsxs as u, Fragment as o } from "react/jsx-runtime";
import { FormattedDate as m, FormattedMessage as c, FormattedNumber as t } from "react-intl";
function d({
  value: n
}) {
  return n ? /* @__PURE__ */ e("span", { title: `${n}`, children: /* @__PURE__ */ e(
    m,
    {
      second: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      day: "numeric",
      month: "long",
      value: n
    }
  ) }) : null;
}
function a({
  name: n,
  value: r
}) {
  if (r == null)
    return null;
  const i = r.toLowerCase().replace(/[^a-z0-9_]/g, "");
  return /* @__PURE__ */ e(c, { id: `enums.${n}.${i}` });
}
function f({
  value: n,
  currency: r = "BRL"
}) {
  return n ? /* @__PURE__ */ e(t, { value: n, style: "currency", currency: r }) : null;
}
function p({
  value: n
}) {
  return n == null ? null : /* @__PURE__ */ u(o, { children: [
    /* @__PURE__ */ e(t, { value: n, style: "decimal" }),
    "%"
  ] });
}
export {
  d as IntlDateTime,
  a as IntlEnum,
  f as IntlMoney,
  p as IntlPercentage
};
